import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-container"
}
const _hoisted_2 = {
  id: "lots-catalog-modal",
  class: "site-tabs lots-catalog"
}
const _hoisted_3 = { class: "catalog-header" }
const _hoisted_4 = { class: "lots-tabs" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "lots-controllers stage-b-item" }
const _hoisted_7 = { class: "modal-content" }
const _hoisted_8 = { class: "all-lots-block tabs-content" }
const _hoisted_9 = {
  key: 0,
  class: "empty-result"
}
const _hoisted_10 = { class: "empty-result-label" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "subtitle" }
const _hoisted_13 = {
  key: 1,
  class: "title"
}

import FilterSearch from "@/components/_partials/catalog/FilterSearch.vue";
  import {
    computed,
    markRaw,
    nextTick,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    useAttrs,
    watch
  } from "vue";
  import Popup from "@/components/_partials/Popup.vue";
  import LotDetailsPopup from "@/components/_partials/LotDetailsPopup.vue";
  import type { Swiper as SwiperSlider } from "swiper/types";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { useWindowSize } from "@vueuse/core";
  import { IActiveLot, ILot } from "@/models";
  import Swiper from "@/components/_partials/Swiper.vue";
  import { trans } from "@/utils/trans";
  import LotCard from "@/components/LotCard.vue";
  import apiClient from "@/services/api";

  
export default /*#__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: 'CatalogPopup',
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

  const component = markRaw(LotDetailsPopup);
  const attrs = useAttrs();
  const emit = __emit;
  

  const size = reactive(useWindowSize());
  const state = reactive({
    isVisible: false,
    isShowCarousel: false,
    showControls: true,
    showCarouselTimerId: null,
    customScroll: null,
    modalWrapperHeight: null,
    modalHeight: null,
    lots: [],
    isLoadLots: true,
    resizeObserver: null as ResizeObserver | null,
    swiperParams: {
      slidesPerView: 5,
      slidesPerGroup: 5,
      rows: 2
    }
  });

  const modalBlock = ref<HTMLDivElement>();
  //==================================================================================================
  const activeItem = ref<string>("catalog");
  const auctionStore = useAuctionStore();
  const popup = ref<typeof Popup>();
  const swiperMap = ref<Record<string, { swiper: SwiperSlider; slides: HTMLElement[] }>>({});
  const activeGroupLotNumbers = ref([]);

  const isSearchActive = computed(() => auctionStore.catalog.searchString?.length);

  const auctionLots = computed((): ILot[] => {
    return isSearchActive.value ? auctionStore.catalog.searchLots : auctionStore.lots;
  });

  const favoriteLots = computed(() => {
    return (
      auctionLots.value?.filter((i: ILot) => {
        return auctionStore.user?.favorite_lots?.includes(i.id);
      }) || []
    );
  });

  const lotsWithUserBid = computed(() => {
    return (
      auctionLots.value?.filter((i: ILot) => {
        return auctionStore.user?.bids && i.id in auctionStore.user.bids;
      }) || []
    );
  });

  const lotsNotes = computed(() => {
    return (
      auctionLots.value?.filter((i: ILot) => {
        return (auctionStore.user?.is_admin && i.has_admin_notes) || (!auctionStore.user?.is_admin && i.note?.length);
      }) || []
    );
  });

  const activeTabSlideMap = computed(() => {
    const result = {};
    const swiperData = swiperMap.value[activeItem.value];

    if (swiperData && swiperData.slides?.length) {
      swiperData.slides.forEach((slide, i: number) => {
        result[slide.dataset.id] = i;
      });
    }

    return result;
  });
  const activeLotId = computed(() => auctionStore.activeLot?.id ?? null);
  const numPerRow = computed(() => {
    return `num-per-row-${state.swiperParams?.slidesPerView}`;
  });

  watch(
    () => auctionStore.activeLot,
    (nv: IActiveLot | null) => {
      if (nv) {
        groupSlideTo(nv.id);
      }
    }
  );

  watch(
    () => size.height,
    () => {
      nextTick(() => {
        updateSwiperParams();
      });
    }
  );

  watch(
    () => size.width,
    () => {
      nextTick(() => {
        updateSwiperParams();
      });
    }
  );

  watch(
    () => auctionLots.value,
    () => {
      nextTick(() => {
        updateSwiperSlides();
      });
    }
  );

  watch(
    () => activeItem.value,
    () => {
      nextTick(() => {
        updateSwiperParams();
      });
    }
  );

  watch(
    () => state.isVisible,
    () => {
      nextTick(() => {
        updateSwiperParams();
      });
    }
  );

  const tabs = ref([
    {
      key: "catalog",
      name: "live.catalog.filters.catalog",
      items: auctionLots
    },
    ...(auctionStore.user?.id && !auctionStore.user?.is_admin
      ? [
          {
            key: "my-bids",
            name: "live.catalog.filters.my_bids",
            items: lotsWithUserBid
          }
        ]
      : []),
    ...(auctionStore.user?.id
      ? [
          {
            key: "saved-lots",
            name: "live.catalog.filters.saved_lots",
            items: favoriteLots
          }
        ]
      : []),
    ...(auctionStore.user?.id || auctionStore.user?.is_admin
      ? [
          {
            key: "notes",
            name: "live.catalog.filters.notes",
            items: lotsNotes
          }
        ]
      : [])
  ]);

  const onSliderInit = (swiper: SwiperSlider, key: string) => {
    swiperMap.value[key] = { swiper, slides: Array.from(swiper.slidesEl.querySelectorAll("swiper-slide")) };

    swiper.on("activeIndexChange", () => updateSwiperParams());
    swiper.on("slideChange", () => updateSwiperParams());
    swiper.on("breakpoint", () => updateSwiperParams());
    swiper.on("setTransition", showCarousel);
    swiper.on("sliderMove", showCarousel);
    swiper.on("scrollbarDragMove", showCarousel);

    if (key === "catalog" && swiperMap.value["catalog"] && activeLotId.value) {
      swiperMap.value["catalog"].slides.forEach((slide, i: number) => {
        if (parseInt(slide.dataset.id) === activeLotId.value) {
          groupSlideTo(i, swiperMap.value["catalog"].swiper);
        }
      });
    }
  };

  const slideToActive = () => {
    if (activeLotId.value) {
      groupSlideTo(activeLotId.value);
    }
  };

  const updateActiveGroupLotNumbers = () => {
    const swiperData = swiperMap.value[activeItem.value];
    const slidesPerGroup = state.swiperParams.rows * state.swiperParams.slidesPerView;

    const carouselSize = Math.min(slidesPerGroup, swiperData?.slides?.length || 0);
    const result = new Array(carouselSize);

    if (swiperData?.swiper && swiperData?.slides?.length) {
      const start = swiperData.swiper.activeIndex * state.swiperParams.rows;
      const end = start + carouselSize;
      swiperData.slides.slice(start, end).forEach((slide, i: number) => {
        result[i] = slide.dataset.number;
      });
    }

    activeGroupLotNumbers.value = result.every((i) => !i) ? null : result;
  };

  const updateSwiperSlides = () => {
    Object.keys(swiperMap.value).forEach((key) => {
      const swiper = swiperMap.value[key].swiper;
      swiperMap.value[key].slides =
        swiper.slidesEl && !swiper.slidesEl.destroyed
          ? Array.from(swiper.slidesEl.querySelectorAll("swiper-slide"))
          : [];
    });
    nextTick(() => {
      updateSwiperParams();
    });
  };

  const updateSwiperParams = () => {
    let rows = 2;
    if (size.height < 830) {
      rows = 1;
    }
    Object.entries(swiperMap.value).forEach(([key, sliderData]) => {
      if (key === activeItem.value && sliderData?.swiper?.params) {
        if (sliderData.swiper.params.grid.rows !== rows) {
          sliderData.swiper.params.grid.rows = rows;
          Object.entries(sliderData.swiper.params.breakpoints).forEach(([k, v]) => {
            v.grid = { rows: rows };
          });
        }

        const params = swiperMap.value[activeItem.value]?.swiper.params;
        const slides = swiperMap.value[activeItem.value]?.slides;
        state.showControls = slides?.length > 0 && params.slidesPerView * params.grid.rows < slides?.length;

        nextTick(() => {
          sliderData.swiper.update();
          if (state.showControls) {
            sliderData.swiper.scrollbar.enable();
          } else {
            sliderData.swiper.scrollbar.disable();
          }
        });

        state.swiperParams.slidesPerView = sliderData.swiper.params.slidesPerView;
        state.swiperParams.slidesPerGroup = sliderData.swiper.params.slidesPerGroup;
        state.swiperParams.rows = rows;
      }
    });
    nextTick(() => updateActiveGroupLotNumbers());
  };

  const showCarousel = () => {
    state.isShowCarousel = true;

    if (state.showCarouselTimerId) {
      clearTimeout(state.showCarouselTimerId);
    }

    state.showCarouselTimerId = setTimeout(() => {
      state.isShowCarousel = false;
    }, 1000);
  };

  onMounted(() => {
    activeItem.value = tabs.value[0].key;
    nextTick(() => {
      updateSwiperParams();
    });
    document.addEventListener("keydown", closeByEscapeKey);
  });

  onBeforeUnmount(() => {
    document.removeEventListener("keydown", closeByEscapeKey);
  });

  const groupSlideTo = (lotId: number, swiper = null) => {
    if (activeItem.value) {
      swiper = swiper || swiperMap.value[activeItem.value]?.swiper;
      if (swiper) {
        const slideIndex = activeTabSlideMap.value[lotId];
        if (slideIndex >= 0) {
          swiper.slideTo(Math.floor((slideIndex / 10) * 5));
        }
      }
    }
  };

  const open = () => {
    state.isVisible = true;
    document.body.classList.add("overflow-hidden");
  };
  const close = () => {
    state.isVisible = false;
    document.body.classList.remove("overflow-hidden");
    emit("close");
  };
  const closeByEscapeKey = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      close();
    }
  };

  const openLotDetailsPopup = (lot: ILot) => {
    apiClient.get(`/live/lots/${lot.id}/popup-data`).then((response) => {
      popup.value?.toggleComponent(component, {
        lotProp: Object.assign(lot, response.data)
      });
      popup.value?.open();
    });
  };

  __expose({
    open
  });

return (_ctx: any,_cache: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (state.isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal", [_unref(attrs).class, { 'is-single-row': state.swiperParams.rows === 1 }]]),
              ref_key: "modalBlock",
              ref: modalBlock
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["type-lots-tab-title tab-title", { active: activeItem.value === tab.key }]),
                        "data-target": "lot-tab-content-1",
                        onClick: ($event: any) => (activeItem.value = tab.key),
                        key: tab.key
                      }, _toDisplayString(_unref(trans)(tab.name)), 11, _hoisted_5))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(FilterSearch, { class: "search-block" }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createElementVNode("svg", { class: "icon-search" }, [
                          _createElementVNode("use", { href: "/sprite.svg#search" })
                        ], -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", {
                    class: "modal__close",
                    onClick: close
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["tab-content", { active: tab.key === activeItem.value }]),
                        key: tab.key
                      }, [
                        _createVNode(Swiper, {
                          id: tab.key,
                          class: "lots-list",
                          "breakpoint-key": "lotsLivePopupCatalog",
                          "slides-per-view": 5,
                          "slides-per-group": 5,
                          grid: { rows: 2, fill: 'row' },
                          navigation: state.showControls,
                          scrollbar: state.showControls,
                          mousewheel: true,
                          "check-active-index": true,
                          onSwiperInit: (swiper) => onSliderInit(swiper, tab.key)
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.items, (lot) => {
                              return (_openBlock(), _createBlock(_component_swiper_slide, {
                                key: lot.id,
                                lazy: "true",
                                class: _normalizeClass(['slide-lot', { 'single-row': state.swiperParams.rows === 1 }]),
                                "data-number": lot.lot_number,
                                "data-id": lot.id,
                                onClick: ($event: any) => (openLotDetailsPopup(lot))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(LotCard, {
                                    "lot-data": lot,
                                    "with-title": "",
                                    "catalog-popup": ""
                                  }, null, 8, ["lot-data"])
                                ]),
                                _: 2
                              }, 1032, ["class", "data-number", "data-id", "onClick"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["id", "navigation", "scrollbar", "onSwiperInit"]),
                        (tab.items?.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                (isSearchActive.value)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(trans)("live.catalog.empty_results_with_search_title")) + " \"" + _toDisplayString(_unref(auctionStore).catalog.searchString) + "\" ", 1),
                                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(trans)("live.catalog.empty_results_subtitle")), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(trans)("live.catalog.empty_results_title")), 1))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (activeGroupLotNumbers.value?.length)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(['catalog-popup-lot-carousel', numPerRow.value, { show: state.isShowCarousel }])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeGroupLotNumbers.value, (number) => {
                                return (_openBlock(), _createElementBlock("div", { key: number }, _toDisplayString(number || ""), 1))
                              }), 128))
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", {
        class: "modal-overlay background-fill",
        onClick: close
      }, null, 512), [
        [_vShow, state.isVisible]
      ])
    ])),
    _createVNode(Popup, {
      class: "lot-details-popup full-width",
      ref_key: "popup",
      ref: popup
    }, null, 512)
  ], 64))
}
}

})